import { classicTheme } from './classic';
import type { Theme } from './types';

export type { SymbolProps, Theme } from './types';

/**
 * Registry of available themes.
 *
 * Phase 6 (theme packs) extends this map and adds a picker; nothing in the
 * board components needs to change, because they only ever read slots off the
 * active theme.
 */
export const themes: Record<string, Theme> = {
  [classicTheme.id]: classicTheme,
};

export const defaultTheme = classicTheme;

export function getTheme(id: string): Theme {
  return themes[id] ?? defaultTheme;
}
